module.exports = __webpack_public_path__ + "static/dotted-b362486a7a24b5affe0108c8a83b130f.svg";